<template>
  <div>
    <headerSection :navActiveItem="navActiveItem"></headerSection>
    <slide></slide>
    <product></product>
    <industry></industry>
    <partner></partner>
    <about></about>
    <contact></contact>
    <footerSection></footerSection>
    <a href="#" class="go-top"><i class="fa fa-angle-up"></i></a>
​</div>
</template>
<script>
import headerSection from '../components/header.vue';
import slide from '../components/slide1.vue';
import about from '../components/about.vue';
import partner from '../components/partner.vue';
import industry from '../components/industry.vue';
import product from '../components/product.vue';
import contact from '../components/contact.vue';
import footerSection from '../components/footer.vue';
// import footerSection from '../components/footer2.vue';
import '../../static/css/animate.min.css';
import WOW from '../../static/js/wow.min.js';
  export default {
    components: {
      headerSection,
      slide,
      partner,
      industry,
      product,
      contact,
      footerSection,
      about
    },
    data(){
      return{
        navActiveItem:{
          home:true
        }
      }
    },
    mounted: function() {
      $(window).scroll(function() {
        if ($(this).scrollTop() > 200) {
            $('.go-top').fadeIn(200);
              } else {
                  $('.go-top').fadeOut(200);
             }
          });
            // Animate the scroll to top
          $('.go-top').click(function(event) {
            event.preventDefault();
          $('html, body').animate({scrollTop: 0}, 1000);
      });
      new WOW.WOW().init();
      $('html, body').animate({scrollTop: 0}, 0);
    }
   }
</script>
<style>
 .go-top {
  background-color: #365675;
  box-shadow: 1px 1.732px 12px 0px rgba( 0, 0, 0, .14 ), 1px 1.732px 3px 0px rgba( 0, 0, 0, .12 );
  transition : all 1s ease;
  bottom: 1em;
  right: 1em;
  color: #FFF;
  font-size: 26px;
  display: none;
  position: fixed;
  text-decoration: none;
  width: 40px;
  height: 40px;
  text-align: center;
  border-radius: 100%;
}
.go-top i {
  float: center;
  padding: 0;
  margin: 0;
  line-height: 35px;
}
.go-top:hover {
  background: #c09c9c;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue